export default __webpack_public_path__ + "static/media/activiesBg.6a4351b0.png";